// @theme component
import React, { useCallback } from 'react';
import { prop } from 'ramda';
import { useUserSelector } from '@core/js/store/hooks';
import { useTranslations } from '@core/js/hooks/i18n';
import { useDispatch } from 'react-redux';
import { STEPS_NAME } from '@theme/js/components/main/SmsVerification/constants';
import { Button } from '@core/js/components/common/Button';

import style from './index.scss';
import { hideSMSVereficationDrawerStep, showSmsVerificationPopupAction } from '@theme/js/components/system/App/store/actions';
import { IUserDetails } from '@core/js/hooks/user/store/types';

const SmsVerificationButton = () => {
    const t = useTranslations('playtech.mobile.system.dynamic-change-details.');
    const dispatch = useDispatch();
    const { mobilePhoneVerified } = useUserSelector<IUserDetails>(prop('userDetails'));
    const isPhoneVerified = mobilePhoneVerified === '1';

    const handleVerificationClick = useCallback(() => {
        dispatch(hideSMSVereficationDrawerStep());
        dispatch(showSmsVerificationPopupAction(
            { verificationType: 'default', step: isPhoneVerified ? STEPS_NAME.CHANGE_NUMBER : STEPS_NAME.INITIAL }
        ));
    }, [dispatch, isPhoneVerified]);

    return (
        <div className={style.container}>
            <p className={isPhoneVerified ? style.verifiedPhone : style.notVerifiedPhone}>
                {t(`${isPhoneVerified ? 'phoneVerification' : 'noPhoneVerification'}`)}
            </p>
            <Button
                view="secondary"
                color="info"
                size="small"
                onClick={handleVerificationClick}
            >
                {t(`verification${isPhoneVerified ? '-new' : ''}`)}
            </Button>
        </div>
    );
};

export default SmsVerificationButton;
